import "core-js/modules/es.array.includes.js";
import { defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withModifiers as _withModifiers, unref as _unref, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-51ccfac0"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "ion-no-padding",
  slot: "content"
};
const _hoisted_2 = ["alt", "src"];
const _hoisted_3 = {
  key: 1,
  class: "icon compact-size",
  slot: "start"
};
import { IonAccordionGroup } from '@ionic/vue';
import { computed, onMounted, ref } from 'vue';
import Router, { CHAT_PATH, USERS_PATH } from '@/router';
import useChats from '@/composables/global/use-chats';
import useColumbiaSelfReport from '@/composables/global/use-columbia-self-report';
import useCourses from '@/composables/global/use-courses';
import useInitLoader from '@/composables/global/use-init-loader';
import useLevelPage from '@/composables/global/use-level-page';
import useLevels from '@/composables/global/use-levels';
import usePhq9 from '@/composables/global/use-phq9';
import useProgress from '@/composables/global/use-progress';
import useUsers from '@/composables/global/use-users';
import useViewer from '@/composables/global/use-viewer';
import { errorAlert } from '@/utils/ion-alert';
export default /*#__PURE__*/_defineComponent({
  __name: 'TheShellSideMenuListItem',
  props: {
    item: {},
    iconsOnly: {
      type: Boolean,
      default: false
    }
  },
  emits: ["navToRoute"],
  setup(__props, {
    emit: __emit
  }) {
    const emit = __emit;
    const props = __props;
    const {
      hasUnreadMessages,
      callInProgress
    } = useChats();
    const {
      usersWithUnviewedColumbiaSelfReports
    } = useColumbiaSelfReport();
    const {
      activeCourse
    } = useCourses();
    const {
      appDataInitialized
    } = useInitLoader();
    const {
      assignedCustomLevels
    } = useLevels();
    const {
      usersWithUnviewedPhq9Reports
    } = usePhq9();
    const {
      progress
    } = useProgress();
    const {
      pageLockedUsers
    } = useUsers();
    const {
      viewer,
      isParticipant
    } = useViewer();
    const isLoading = ref(true);
    const accordionGroupRef = ref();
    const isSelected = computed(() => {
      return Router.currentRoute.value.path.includes(props.item.path);
    });
    const itemColor = computed(() => {
      return isSelected.value ? 'primary' : 'menu-icon';
    });
    const hasUnreadChatMessages = computed(() => {
      return props.item.path === CHAT_PATH && hasUnreadMessages.value;
    });
    const hasCallingProgress = computed(() => {
      return props.item.path === CHAT_PATH && callInProgress.value;
    });
    const hasUnreadUserItems = computed(() => {
      const hasUnviewedColumbiaSelfReports = usersWithUnviewedColumbiaSelfReports.value.length > 0;
      const hasUnviewedPhq9Reports = usersWithUnviewedPhq9Reports.value.length > 0;
      const hasPagedLockedUsers = pageLockedUsers.value.length > 0;
      return props.item.path === USERS_PATH && (hasUnviewedColumbiaSelfReports || hasUnviewedPhq9Reports || hasPagedLockedUsers);
    });
    const showUnreadIndicator = computed(() => {
      return hasUnreadChatMessages.value || hasUnreadUserItems.value || hasCallingProgress.value;
    });
    function toggleAccordion() {
      if (!accordionGroupRef.value) return;
      const accordionElement = accordionGroupRef.value.$el;
      if (accordionElement.value === 'levels') {
        accordionElement.value = undefined;
      } else {
        accordionElement.value = 'levels';
      }
    }
    async function openLevel(level) {
      var _progress$value;
      const {
        fetchPage,
        fetchNumPage,
        routeNav
      } = useLevelPage(level.id);
      const levelProgress = (_progress$value = progress.value) === null || _progress$value === void 0 || (_progress$value = _progress$value.levelsProgress) === null || _progress$value === void 0 ? void 0 : _progress$value[level.id];
      let page;
      if (levelProgress !== null && levelProgress !== void 0 && levelProgress.latestPage) {
        page = await fetchPage(levelProgress === null || levelProgress === void 0 ? void 0 : levelProgress.latestPage);
        if (page === undefined) page = await fetchNumPage(1);
      } else {
        page = await fetchNumPage(1);
      }
      if (page) {
        routeNav(page).catch(error => errorAlert({
          error
        }));
      } else {
        errorAlert({
          error: 'Unable to find first page of level'
        });
      }
    }
    function levelAccess(levelNumber) {
      var _viewer$value;
      if (!isParticipant.value) return false;
      if (activeCourse.value === undefined) return true;
      const userAccess = (_viewer$value = viewer.value) === null || _viewer$value === void 0 || (_viewer$value = _viewer$value.courses) === null || _viewer$value === void 0 ? void 0 : _viewer$value[activeCourse.value.id];
      switch (userAccess) {
        case 1:
          if (levelNumber > 1) return true;
          return false;
        case 0:
          // Unlocked Levels: All
          return false;
        case -1:
          // Unlocked Levels: None
          return true;
        default:
          return userAccess === undefined || levelNumber > userAccess;
      }
    }
    onMounted(async () => {
      await appDataInitialized();
      isLoading.value = false;
    });
    return (_ctx, _cache) => {
      const _component_ion_icon = _resolveComponent("ion-icon");
      const _component_ion_button = _resolveComponent("ion-button");
      const _component_ion_buttons = _resolveComponent("ion-buttons");
      const _component_ion_label = _resolveComponent("ion-label");
      const _component_ion_item = _resolveComponent("ion-item");
      const _component_ion_avatar = _resolveComponent("ion-avatar");
      const _component_ion_list = _resolveComponent("ion-list");
      const _component_ion_accordion = _resolveComponent("ion-accordion");
      const _component_ion_menu_toggle = _resolveComponent("ion-menu-toggle");
      return _openBlock(), _createBlock(_component_ion_menu_toggle, {
        "auto-hide": false,
        class: "side-menu-item"
      }, {
        default: _withCtx(() => [_ctx.iconsOnly ? (_openBlock(), _createBlock(_component_ion_buttons, {
          key: 0,
          class: "menu-background ion-padding",
          mode: "md"
        }, {
          default: _withCtx(() => [_createVNode(_component_ion_button, {
            color: itemColor.value,
            disabled: isLoading.value,
            mode: "md",
            onClick: _cache[0] || (_cache[0] = $event => emit('navToRoute'))
          }, {
            default: _withCtx(() => [_ctx.item.iconSrc ? (_openBlock(), _createBlock(_component_ion_icon, {
              key: 0,
              slot: "icon-only",
              src: _ctx.item.iconSrc.base64
            }, null, 8, ["src"])) : (_openBlock(), _createBlock(_component_ion_icon, {
              key: 1,
              slot: "icon-only",
              name: _ctx.item.icon
            }, null, 8, ["name"])), showUnreadIndicator.value ? (_openBlock(), _createBlock(_component_ion_icon, {
              key: 2,
              name: "ellipse",
              color: "danger",
              class: "unviewed-badge icon-only",
              slot: "icon-only"
            })) : _createCommentVNode("", true)]),
            _: 1
          }, 8, ["color", "disabled"])]),
          _: 1
        })) : _ctx.item.isLevelItem ? (_openBlock(), _createBlock(_unref(IonAccordionGroup), {
          key: 1,
          ref_key: "accordionGroupRef",
          ref: accordionGroupRef
        }, {
          default: _withCtx(() => [_createVNode(_component_ion_accordion, {
            class: "ion-no-padding",
            value: "levels"
          }, {
            default: _withCtx(() => [_createVNode(_component_ion_item, {
              id: "accordion-item",
              disabled: isLoading.value,
              slot: "header",
              color: "menu",
              mode: "md",
              lines: "full",
              onClick: _cache[1] || (_cache[1] = _withModifiers($event => emit('navToRoute'), ["stop"]))
            }, {
              default: _withCtx(() => [_ctx.item.iconSrc ? (_openBlock(), _createBlock(_component_ion_icon, {
                key: 0,
                slot: "start",
                src: _ctx.item.iconSrc.base64,
                color: itemColor.value
              }, null, 8, ["src", "color"])) : (_openBlock(), _createBlock(_component_ion_icon, {
                key: 1,
                slot: "start",
                name: _ctx.item.icon,
                color: itemColor.value
              }, null, 8, ["name", "color"])), _createVNode(_component_ion_label, null, {
                default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.item.label), 1)]),
                _: 1
              }), _createVNode(_component_ion_icon, {
                slot: "end",
                class: "ion-accordion-toggle-icon",
                name: 'chevron-down',
                onClick: _withModifiers(toggleAccordion, ["stop"])
              })]),
              _: 1
            }, 8, ["disabled"]), _createElementVNode("div", _hoisted_1, [_createVNode(_component_ion_list, {
              class: "ion-no-padding menu-background"
            }, {
              default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(assignedCustomLevels), level => {
                return _openBlock(), _createBlock(_component_ion_item, {
                  button: "",
                  key: level.id,
                  color: "menu",
                  mode: "md",
                  onClick: $event => openLevel(level),
                  disabled: levelAccess(level.num),
                  class: "sub-item"
                }, {
                  default: _withCtx(() => [level.icon ? (_openBlock(), _createBlock(_component_ion_avatar, {
                    key: 0,
                    "aria-hidden": "true",
                    slot: "start",
                    class: "compact-size"
                  }, {
                    default: _withCtx(() => [_createElementVNode("img", {
                      alt: level.iconAlt,
                      src: level.icon
                    }, null, 8, _hoisted_2)]),
                    _: 2
                  }, 1024)) : (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(level.num), 1)), _createVNode(_component_ion_label, null, {
                    default: _withCtx(() => [_createTextVNode(_toDisplayString(level.abbreviatedTitle || level.title), 1)]),
                    _: 2
                  }, 1024)]),
                  _: 2
                }, 1032, ["onClick", "disabled"]);
              }), 128))]),
              _: 1
            })])]),
            _: 1
          })]),
          _: 1
        }, 512)) : (_openBlock(), _createBlock(_component_ion_item, {
          key: 2,
          button: "",
          disabled: isLoading.value,
          color: "menu",
          mode: "md",
          onClick: _cache[2] || (_cache[2] = $event => emit('navToRoute'))
        }, {
          default: _withCtx(() => [_ctx.item.iconSrc ? (_openBlock(), _createBlock(_component_ion_icon, {
            key: 0,
            slot: "start",
            src: _ctx.item.iconSrc.base64,
            color: itemColor.value
          }, null, 8, ["src", "color"])) : (_openBlock(), _createBlock(_component_ion_icon, {
            key: 1,
            slot: "start",
            name: _ctx.item.icon,
            color: itemColor.value
          }, null, 8, ["name", "color"])), showUnreadIndicator.value ? (_openBlock(), _createBlock(_component_ion_icon, {
            key: 2,
            name: "ellipse",
            color: "danger",
            class: "unviewed-badge",
            slot: "start"
          })) : _createCommentVNode("", true), _createVNode(_component_ion_label, null, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.item.label), 1)]),
            _: 1
          })]),
          _: 1
        }, 8, ["disabled"]))]),
        _: 1
      });
    };
  }
});